import { render } from "./TaskPlatforms.vue?vue&type=template&id=248f6452"
import script from "./TaskPlatforms.vue?vue&type=script&lang=js"
export * from "./TaskPlatforms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__